<template>
  <v-card class="d-flex justify-center flex-column pa-6">
    <div class="d-flex flex-column">
      <span
        :class="$style.widget_title"
        class="display-3"
      >
        Лицензии ПО АТОЛ
      </span>
    </div>
    <div :class="$style.diagram_wrapper">
      <div class="d-flex justify-center mt-9">
        <apexchart
          type="donut"
          :options="chartOptions"
          :series="series"
          :class="$style.donut_size"
        />
      </div>

      <div>
        <div class="d-flex justify-space-between">
          <div>
            <span>Количество лицензий ПО АТОЛ</span>
          </div>
          <div>
            <span class="font-weight-bold">{{ software_licenses_count }}</span>
          </div>
        </div>

        <div
          v-for="item in software_licenses"
          :key="item.title"
        >
          <div :class="$style.description_items_wrapper">
            <div class="d-flex justify-space-between">
              <div
                :class="[$style.description_label_container]"
                :style="{ backgroundColor: colors[software_licenses.indexOf(item)] }"
              />
              <span class="ml-4">{{ item.title }}</span>
            </div>
            <div>
              <span class="headline font-weight-bold">{{ item.value }}</span>
              <!--  <span class="headline font-weight-bold">{{ item.value }} ({{ item.percent }}%)</span>-->
            </div>
          </div>
        </div>
      </div>

    </div>
  </v-card>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import { widgets_store, software_licenses_store } from '@/store';
import { SoftwareLicenses } from '@/modules/software-licenses/types';

const { state } = widgets_store;

@Component({
  components: {
    apexchart: () => import('vue-apexcharts'),
  },
})
export default class WidgetSoftwareLicenses extends Vue {
  get software_licenses() {
    return state.widgets.software_licenses?.items;
  }

  get software_licenses_count() {
    return state.widgets.software_licenses?.total_count;
  }

  colors = [
    '#083DC7', '#9BB2EC', '#477DE4',
  ]

  get chartOptions() {
    return {
      chart: {
        type: 'donut',
        toolbar: {
          show: false,
        },
        events: {
          dataPointMouseEnter: (event: any) => {
            event.target.style.cursor = 'pointer';
          },
          dataPointSelection: (event: any, chartContext: any, config: any) => {
            if (this.software_licenses && this.software_licenses[config.dataPointIndex]) {
              software_licenses_store.mutations.UPD_FILTER_KEY(
                { key: 'statuses', value: [this.software_licenses[config.dataPointIndex].slug] },
              );

              this.$router.push({ name: SoftwareLicenses.Pages.SOFTWARE_LICENSES });
            }
          },
        },
      },
      plotOptions: {
        pie: {
          donut: {
            size: '76%',
          },
        },
      },
      labels: this.software_licenses?.map((item) => item.title),
      dataLabels: {
        enabled: false,
      },
      colors: this.colors,
      legend: {
        show: false,
      },
      tooltip: {
        enabled: true, // всплывающая подсказка при наведении
      },
    };
  }

  get series() {
    return this.software_licenses?.map((item) => item.value);
  }
}

</script>

<style module lang="scss">
.widget_box {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.widget_title {
  font-style: 24px;
  font-weight: 600;
  line-height: 32px;
  color: #13141C;
}
.diagram_wrapper {
  width: 100%;
}
.description_items_wrapper {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  margin: 16px 0;
}
.description_label_container {
  width: 20px;
  height: 20px;
  border-radius: 4px;
}
.donut_size {
  width: 400px;
  height: 312px;
}

@media (min-width: 960px) and (max-width: 1439px) {
  .donut_size {
    width: 360px;
    height: 312px;
  }
}
</style>
